import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CloudFunctions, download, getFunctionsUrl } from '../../utils/utils';
import styles from './Course.module.scss';
import { StatusBadge } from './CourseStatus';

export type CourseCertificateButtonProps = {
  course: any;
  currentUser: any;
  isFetching: boolean;
  courseUnlocked: boolean;
  setIsFetching: (isFetching: boolean) => void;
};

type CourseDetailsProps = CourseCertificateButtonProps;

const CourseDetails = ({
  course,
  currentUser,
  isFetching,
  courseUnlocked,
  setIsFetching,
}: CourseDetailsProps) => {
  return (
    <aside className={`${styles.courseHeaderCard} ${styles.courseSidebar} surface-card`}>
      {!!course.header && <div className={styles.courseHeaderImage} style={{ backgroundImage: `url(${course.header})` }} />}

      <div className={styles.courseCompletion}>
        <StatusBadge completed={course.completed} status={course.status} className={`${styles.courseBadge} ${!course.completed ? styles.courseBadgeIncomplete : ''}`} />
      </div>

      <div className={styles.courseHeaderTitle}>{course.name}</div>

      {course.withCertificate && (
        <div className={styles.courseActions}>
          <CourseCertificateButton
            course={course}
            currentUser={currentUser}
            isFetching={isFetching}
            courseUnlocked={courseUnlocked}
            setIsFetching={setIsFetching}
          />
        </div>
      )}

      {!!course.description && (
        <div className={styles.courseHeaderDescription}>
          {course.description.map((segment, i) => (
            <div key={i.toString()}>{segment}</div>
          ))}
        </div>
      )}
    </aside>
  );
};

const CourseCertificateButton = ({
  course,
  currentUser,
  isFetching,
  courseUnlocked,
  setIsFetching,
}: CourseCertificateButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      className="tootor-button tootor-button--basic"
      onClick={
        !course.completed || !courseUnlocked
          ? null
          : async () => {
              setIsFetching(true);
              const response = await fetch(getFunctionsUrl(CloudFunctions.GenerateCertificationStream), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  courseId: course.id,
                  uid: currentUser.uid,
                  token: await currentUser.getIdToken(true),
                  companyId: course.companies?.[0]?.id,
                }),
              });
              setIsFetching(false);
              await download(response);
            }
      }
      disabled={isFetching || !course.completed || !courseUnlocked}
    >
      <span className={'text-nowrap'}>{t('course.labels.scaricaAttestato')}</span>
    </Button>
  );
};

export { CourseCertificateButton, CourseDetails };
